import FlexInputContainer from '../../../../common/styled/FlexInputContainer/FlexInputContainer';
import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
}

const Form = (props: Props) => {
    const { baseInputProps } = props;
    const { data } = baseInputProps;

    return (
        <>
            <CustomInput {...baseInputProps} name='item.description' InputProps={{ readOnly: true }} />

            <CustomInput {...baseInputProps} name='actionDescription' rows={3} multiline InputProps={{ readOnly: data.isActionReadOnly }} />

            <CustomInput {...baseInputProps} name='actionTitle' InputProps={{ readOnly: data.isActionReadOnly }} />

            <FlexInputContainer>
                <CustomInput {...baseInputProps} name='reductionTarget' type='number' inputProps={{ readOnly: true }} />
                <CustomInput {...baseInputProps} name='dueDate' inputProps={{ readOnly: true }} />
                <CustomInput {...baseInputProps} name='certificationYear' inputProps={{ readOnly: true }} />
            </FlexInputContainer>

            <CustomInput {...baseInputProps} name='actionResponsible' />

            {(data.actionDeadline || data.actionCost) && (
                <FlexInputContainer>
                    <CustomInput {...baseInputProps} name='actionDeadline' inputProps={{ maxLength: 10 }} />
                    <CustomInput {...baseInputProps} name='actionCost' type='number' inputProps={{ min: 0, step: 0.01 }} />
                </FlexInputContainer>
            )}

            {(data.actionBenefit) && (
                <CustomInput {...baseInputProps} name='actionBenefit' rows={3} multiline />
            )}

            <FlexInputContainer>
                {/*<CustomInput {...baseInputProps} name='actionDone' select booleanValues>
                    <MenuItem value={'1'} >
                        {t('dialogs.generic.flag_yes')}
                    </MenuItem>
                    <MenuItem value={'0'} >
                        {t('dialogs.generic.flag_no')}
                    </MenuItem>
                </CustomInput>*/}

                {data.actionTarget && (
                    <CustomInput {...baseInputProps} name='actionTarget' type='number' />
                )}
            </FlexInputContainer>
        </>
    );
};

export default Form;
